var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_52-google-play"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.472,227.608c17.25,12.85,17.25,41.79,1.08,54.641l-45.509,25.77l-67.441-53.09l67.607-52.077     L430.472,227.608z",
    style: {
      fill: "#FFC801"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.396,307.769l-0.01-0.01h-0.01l-67.835-52.801l-0.021-0.02l-0.01,0.01l0.021,0.021    l-0.021-0.021l-0.03-0.03l-0.239,0.181l-249.79,190.25v7.95c-0.001,10.503,2.457,21.705,10.845,25.595    c11.052,5.125,27.177-4.892,27.177-4.892L386.396,307.769z",
    style: {
      fill: "#F93647"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "318.242,255.099 68.452,445.349 68.452,60.588 318.182,255.019    ",
    style: {
      fill: "#00D3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.452,56.738v3.85l249.729,194.431l0.061,0.08l0.239-0.181l0.021-0.01l0.1-0.08l67.607-51.685    c0,0-217.433-129.992-280.465-167.482c-2.742-1.631-9.313-5.768-17.192-3.188C79.113,35.565,68.452,46.793,68.452,56.738z",
    style: {
      fill: "#00EF77"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreSm);
export default __webpack_public_path__ + "static/media/play-store-sm.ad666a076a165da2e62cf76c1fc5fa7e.svg";
export { ForwardRef as ReactComponent };